import { FC } from 'react';
import { useFormContext } from '../../../../../../contexts/FormContext';
import { FormType, SocialPlatform } from '../../../../../../types/FormTypes';
import { BasicButton } from '../../../../../shared/buttons/BasicButton';
import { FacebookCard } from './FacebookCard';
import { InstagramCard } from './InstagramCard';
import { LinkedInCard } from './LinkedInCard';

import styles from './SocialOutputs.module.css';
import { TwitterCard } from './TwitterCard';

export const SocialOutputs: FC = () => {
  const {
    formType,
    socialInput,
    editedOutput,
    generatedOutput,
    lastGeneratedFormat,
    submitContentForm,
    loading,
  } = useFormContext();

  if (!socialInput) return null;

  const LoadMoreButton = () => {
    if (generatedOutput.length === 0) return null;

    if (!lastGeneratedFormat || formType !== lastGeneratedFormat.formType)
      return null;

    if (
      lastGeneratedFormat.formType === FormType.SOCIAL &&
      lastGeneratedFormat.platform !== socialInput.platform
    )
      return null;
    return (
      <BasicButton
        type="button"
        text="Load More"
        disabled={loading}
        loading={loading}
        onClick={() => {
          submitContentForm({
            values: socialInput,
            formType: FormType.SOCIAL || FormType.PERSONA,
            keepPreviousResponses: true,
          });
        }}
        extraStyles={{
          margin: '30px auto',
          zIndex: 5,
        }}
      />
    );
  };

  return (
    <div className={styles['container']}>
      {editedOutput.map(({ text, id }, index) => {
        switch (lastGeneratedFormat?.platform) {
          case SocialPlatform.FACEBOOK:
            return (
              <FacebookCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          case SocialPlatform.INSTAGRAM:
            return (
              <InstagramCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          default:
          case SocialPlatform.TWITTER:
            return (
              <TwitterCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
          case SocialPlatform.LINKEDIN:
            return (
              <LinkedInCard
                key={text}
                text={text}
                responseIndex={index}
                id={id ?? ''}
              />
            );
        }
      })}
      <LoadMoreButton />
    </div>
  );
};
